/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from 'react';
import moment from 'moment';

import AppTable from 'components/appTable';
import SearchBox from 'components/form/searchBox';
import Gap from 'components/gap';
import PanelBoxLayout from 'components/layout/panelBox';
import { useActions } from 'common/hooks/useActions';
import PrimaryButton from 'components/form/buttons/primaryButton';
import EventFilterPopup from '../filterForm';

import * as S from './styles';
import * as T from 'common/types';
import { Link } from 'react-router-dom';
import { ReactSVG } from 'react-svg';

interface IProps {
  data: [];
  departments: [];
  ticketCategory: [];
}

export default function EventsTable({ data, departments, ticketCategory }: IProps) {
  const { ticketsRequestAction } = useActions();
  const [meta, setMeta] = useState({
    page: 1,
    page_size: 1000,
    search: '',
    type: ''
  });

  const fetchData = () => {
    ticketsRequestAction(meta);
  };

  useEffect(() => {
    fetchData();
  }, [meta]);

  // const handleChangePage = (page: number) => {
  //   setMeta({ ...meta, page });
  // };

  // const handleChangePageSize = (page_size: number) => {
  //   setMeta({ ...meta, page_size });
  // };

  return (
    <S.Content>
      <PanelBoxLayout>
        <S.Head>
          <SearchBox
            onChange={(e) => setMeta({ ...meta, search: e })}
            placeholder="Search"
            inputStyle={{ height: 36, borderRadius: 10, fontSize: 12 }}
            style={{ width: 500 }}
          />
          <EventFilterPopup
            setFilter={setMeta}
            filter={meta}
            departments={departments}
            ticketCategory={ticketCategory}
          />
        </S.Head>
        <Gap size="20px" />
        <AppTable
          headers={[
            { id: 1, title: 'ID', dir: 'left' },
            { id: 4, title: 'Title', dir: 'left' },
            { id: 5, title: 'Type', dir: 'left' },
            { id: 6, title: 'Capacity', dir: 'left' },
            { id: 7, title: 'Department', dir: 'left' },
            { id: 8, title: 'Date', dir: 'left' },
            { id: 9, title: 'Edit' },
            { id: 10, title: '' }
          ]}
          data={data}
          altanfeethiFields={{
            id: (item: T.Pages.TicketItem) => <S.Div className="text-left">{item?.id}</S.Div>,

            title: (item: T.Pages.TicketItem) => <S.Div className="text-left captal">{item.title}</S.Div>,
            type: (item: T.Pages.TicketItem) => <S.Div className="text-left">{item.category?.title}</S.Div>,
            capacity: (item: T.Pages.TicketItem) => <S.Div className="text-left">{item?.requestLocation}</S.Div>,
            department: (item: T.Pages.TicketItem) => <S.Div className="text-left">{item.category?.title}</S.Div>,
            createdAt: (item: T.Pages.TicketItem) => (
              <S.Div className="text-left captal">{moment(item.createdAt).format('YYYY.MM.DD HH:MM')}</S.Div>
            ),
            edit: (item: T.Pages.TicketItem) => (
              <Link to={`/panel/events/${item.id}`}>
                <ReactSVG
                  src="/icons/stroke/pen-card.svg"
                  beforeInjection={(svg) => {
                    svg.setAttribute('stroke', `#8A93AC`);
                    // svg.setAttribute("width", `12px`);
                    // svg.setAttribute("heigth", `12px`);
                  }}
                  wrapper="span"
                />
              </Link>
            ),
            requestLocation: (item: T.Pages.TicketItem) => (
              <S.Div className="text-left captal">
                <PrimaryButton
                  style={{
                    height: 28,
                    fontSize: 12,
                    background: '#8A93AC',
                    color: 'var(--white)',
                    width: 94,
                    margin: 'auto',
                    borderRadius: 8
                  }}
                  link={`/panel/events/contributors/${item.id}`}
                >
                  Details
                </PrimaryButton>
              </S.Div>
            )
          }}
        />
      </PanelBoxLayout>
      {/* {data.totalPages ? (
        <PaginationApp
          page={meta.page}
          count={meta.page_size * data.totalPages}
          handleChangePage={(page: number) => handleChangePage(page)}
          key={data.totalPages}
          pageSize={meta.page_size}
          handleChangeTake={handleChangePageSize}
        />
      ) : (
        <></>
      )} */}
    </S.Content>
  );
}
